import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import './index.css'

// Nav Bar Menu Links
import NavBar from './Components/NavBar';
import Banner from './Components/Banner';
import Services from './Components/Services';
import AboutUs from './Components/AboutUs';
import Team from './Components/Team';
import Contact from './Components/Contact';
import Newsletter from './Components/Newsletter';
import Testimonial from './Components/Testimonial';

// Services Links
import HairServicePage from './ServiceComponents/HairServicePage';
import HairServicePage1 from './ServiceComponents/HairServicePage1';
import HairServicePage2 from './ServiceComponents/HairServicePage2';
import HairServicePage3 from './ServiceComponents/HairServicePage3';
import HairServicePage4 from './ServiceComponents/HairServicePage4';
import HairAccessoriesPage from './ServiceComponents/HairAccessoriesPage';
import AppWebDevPage from './ServiceComponents/AppWebDevPage';
import GraphicDesignPage from './ServiceComponents/GraphicDesignPage';
import GraphicDesignPage1 from './ServiceComponents/GraphicDesignPage1';
import GraphicDesignPage2 from './ServiceComponents/GraphicDesignPage2';
import GraphicDesignPage3 from './ServiceComponents/GraphicDesignPage3';
import TrainingPage from './ServiceComponents/TrainingPage';
import ImgExpansionPage from './ServiceComponents/ImgExpansionPage';

// success page
import Success from './Components/Success';



// All Image Data
import { peerlessDataForOurHair, peerlessDataForOurCrochets, peerlessDataForRevampingAndRestyling, peerlessDataForOurWeaves , peerlessDataForTestimonial, peerlessDataForAccessories, peerlessDataForOurBraids, peerlessDataEflyers, peerlessDataForLogos, peerlessDataForBanAndLetter, peerlessDataForBrandAndId, peerlessDataForVids } from './Components/PeerlessData';






function App() {

    // making an array of all the image data

    const imageDataBase = [...peerlessDataForOurHair, ...peerlessDataForOurCrochets, ...peerlessDataForOurWeaves, ...peerlessDataForRevampingAndRestyling, ...peerlessDataForTestimonial, ...peerlessDataForAccessories, ...peerlessDataForOurBraids, ...peerlessDataEflyers, ...peerlessDataForLogos, ...peerlessDataForBanAndLetter, ...peerlessDataForBrandAndId, ...peerlessDataForVids]

  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [isWindowReduced, setIsWindowReduced] = React.useState(false);
  const [isFromContactJs, setisFromContactJs] = React.useState(false);
  const [slidesToShow0, setSlidesToShow0] = React.useState(5);
  const [slidesToShow1, setSlidesToShow1] = React.useState(6);
  const [slidesToScroll0, setSlidesToScroll0] = React.useState(3)
  const [slidesToShow2, setSlidesToShow2] = React.useState(2);
  const [slidesToShow3, setSlidesToShow3] = React.useState(3);

  // initial slide states
  const [sliderState, setSliderState] = React.useState({currentSlide: 0})
  const [sliderState1, setSliderState1] = React.useState({currentSlide: 0})
  const [sliderState2, setSliderState2] = React.useState({currentSlide: 0})
  const [sliderState3, setSliderState3] = React.useState({currentSlide: 0})
  const [sliderState4, setSliderState4] = React.useState({currentSlide: 0})
  const [sliderState5, setSliderState5] = React.useState({currentSlide: 0})
  const [sliderState6, setSliderState6] = React.useState({currentSlide: 0})
  const [sliderState7, setSliderState7] = React.useState({currentSlide: 0})
  const [sliderState8, setSliderState8] = React.useState({currentSlide: 0})
  const [sliderState9, setSliderState9] = React.useState({currentSlide: 0})
  const [sliderState10, setSliderState10] = React.useState({currentSlide: 0})
  const [sliderState11, setSliderState11] = React.useState({currentSlide: 0})
  const [sliderState12, setSliderState12] = React.useState({currentSlide: 0})

  

  const [status, setStatus] = React.useState("Send");
  const [status1, setStatus1] = React.useState("Subscribe");
  const [navLinks, setNavLinks] = React.useState({

    homeLink: true,
    serviceLink: false,
    aboutLink: false,
    contactLink: false, 
    signUpLink: false,
    testimonialLink: false,
    membersLink: false,
    hairServicesLink: false,
    hairServicesLink1: false,
    hairServicesLink2: false,
    hairServicesLink3: false,
    hairServicesLink4: false,
    hairAccessoriesLink: false,
    appWebDevLink: false,
    graphicDesignLink: false,
    graphicDesignLink1: false,
    graphicDesignLink2: false,
    graphicDesignLink3: false,

    trainingLink: false,
    expansionLinkForImages: false,

    successLink: false,

});


// Initializing image data for enlargement
const [imageData, setImageData] = React.useState({

  url : null,
  folder : null,
  imgName: null,
  info: null,
});



// Check for collapsed nav bar
React.useEffect(()=>{

  // Saved Session loader
  const handleSessionLoader = () => {

      
      const currentSession = JSON.parse(sessionStorage.getItem('currentSession'));
      if(currentSession){
      setNavLinks(currentSession)}
  }
  handleSessionLoader()

  const handleResize = () =>{

    window.innerWidth <= 1000 ?  setIsWindowReduced(true) : setIsWindowReduced(false);

  };

  window.addEventListener('resize', handleResize);
  handleResize()

  return ()=>{

      window.removeEventListener('resize', handleResize)

    }

}, [setIsWindowReduced]);


// Nav Switches

// visible menu and their session updates
const handleHome = () =>{
  
  setNavLinks({homeLink: true});
  sessionStorage.setItem("currentSession", JSON.stringify({homeLink: true}));

};
const handleServices = () =>{
  setNavLinks({serviceLink: true})
  sessionStorage.setItem("currentSession", JSON.stringify({serviceLink: true}));

};
const handleContact = () =>{
  setNavLinks({contactLink: true})
  sessionStorage.setItem("currentSession", JSON.stringify({contactLink: true}));
};
const handleAbout = () =>{
  
  setNavLinks({aboutLink: true})
  sessionStorage.setItem("currentSession", JSON.stringify({aboutLink: true}));

};
const handleSignUp = () =>{
  
  setNavLinks({ signUpLink: true})
  sessionStorage.setItem("currentSession", JSON.stringify({signUpLink: true}));

};
const handleTestimonial = () => {
  
  setNavLinks({ testimonialLink: true})
  sessionStorage.setItem("currentSession", JSON.stringify({testimonialLink: true}));


};


const handleMenuToggle = () => {

  setIsMenuOpen(!isMenuOpen);
};


// service Links
const handleServiceLinks = (id) => {

    if (id ===1){
      setNavLinks({hairServicesLink:true});
      sessionStorage.setItem("currentSession", JSON.stringify({hairServicesLink: true}));
    }else if(id===2){
      setNavLinks({hairAccessoriesLink:true});
      sessionStorage.setItem("currentSession", JSON.stringify({hairAccessoriesLink: true}));
    }else if(id===3) {
      setNavLinks({appWebDevLink:true});
      sessionStorage.setItem("currentSession", JSON.stringify({appWebDevLink: true}));
    }else if(id===4) {
      setNavLinks({graphicDesignLink:true});
      sessionStorage.setItem("currentSession", JSON.stringify({graphicDesignLink: true}));
    }else if(id===5){
      setNavLinks({trainingLink:true});
      sessionStorage.setItem("currentSession", JSON.stringify({trainingLink: true}));
    }

    return 
};

// Youtube Links
const vidLinkSettings = (id) => {
  return id === 113 ? (
    "https://www.youtube.com/embed/xSUhdj5BrKc"
  ) : id === 114 ? (
    "https://www.youtube.com/embed/jv2pr1SCbIc"
  ) : id === 115 ? (
    "https://www.youtube.com/embed/Cc8qIvqPt2s"
  ) : null;
};

 // Enlarge Image
 const handleImageExpansion = (id)=>{

  imageDataBase.map((data)=>{

      if (id===data.id){  

         setImageData({url: data.image, folder: data.folder, imgName: data.name, info: data.info,})
     

       
     };

     return null;
     

   }  
 
 )

   // show large image
   setNavLinks({expansionLinkForImages: true})

};

// update local storage with sliderstate
const handleAfterChange =(currentSlide) =>{
    setSliderState({currentSlide});
    sessionStorage.setItem('sliderState', JSON.stringify({currentSlide})); 
};
const handleAfterChange1 =(currentSlide) =>{
  setSliderState1({currentSlide});
  sessionStorage.setItem('sliderState1', JSON.stringify({currentSlide})); 
};
const handleAfterChange2 =(currentSlide) =>{
  setSliderState2({currentSlide});
  sessionStorage.setItem('sliderState2', JSON.stringify({currentSlide})); 
};
const handleAfterChange3 =(currentSlide) =>{
  setSliderState3({currentSlide});
  sessionStorage.setItem('sliderState3', JSON.stringify({currentSlide})); 
};
const handleAfterChange4 =(currentSlide) =>{
  setSliderState4({currentSlide});
  sessionStorage.setItem('sliderState4', JSON.stringify({currentSlide})); 
};
const handleAfterChange5 =(currentSlide) =>{
  setSliderState5({currentSlide});
  sessionStorage.setItem('sliderState5', JSON.stringify({currentSlide})); 
};
const handleAfterChange6 =(currentSlide) =>{
  setSliderState6({currentSlide});
  sessionStorage.setItem('sliderState6', JSON.stringify({currentSlide})); 
};
const handleAfterChange7 =(currentSlide) =>{
  setSliderState7({currentSlide});
  sessionStorage.setItem('sliderState7', JSON.stringify({currentSlide})); 
};
const handleAfterChange8 =(currentSlide) =>{
  setSliderState8({currentSlide});
  sessionStorage.setItem('sliderState8', JSON.stringify({currentSlide})); 
};
const handleAfterChange9 =(currentSlide) =>{
  setSliderState9({currentSlide});
  sessionStorage.setItem('sliderState9', JSON.stringify({currentSlide})); 
};
const handleAfterChange10 =(currentSlide) =>{
  setSliderState10({currentSlide});
  sessionStorage.setItem('sliderState10', JSON.stringify({currentSlide})); 
};
const handleAfterChange11 =(currentSlide) =>{
  setSliderState11({currentSlide});
  sessionStorage.setItem('sliderState11', JSON.stringify({currentSlide})); 
};
const handleAfterChange12 =(currentSlide) =>{
  setSliderState12({currentSlide});
  sessionStorage.setItem('sliderState12', JSON.stringify({currentSlide})); 
};





  return (
    <div className='app-container'>

      <div className="navBarCustom">

          <NavBar 
            isMenuOpen={isMenuOpen} 
            onMenuToggle={handleMenuToggle} 
            handleServices={handleServices}
            handleHome = {handleHome}
            handleAbout={handleAbout}
            handleContact={handleContact}
            handleSignUp={handleSignUp}
            handleTestimonial={handleTestimonial}
            setNavLinks={setNavLinks}
          
          />
      </div>
      
      <div className="front-end">

        {/* Nav Menu */}

        {navLinks.homeLink && <Banner handleServices={handleServices} handleContact={handleContact}/>}
        {navLinks.serviceLink && <Services setNavLinks={setNavLinks} handleServiceLinks={handleServiceLinks} isWindowReduced={isWindowReduced}  slidesToShow0={slidesToShow0} setSlidesToShow0={setSlidesToShow0} 
        sliderState={sliderState} setSliderState={setSliderState} handleAfterChange={handleAfterChange} />}
        {navLinks.aboutLink && <AboutUs setNavLinks={setNavLinks}/>}
        {navLinks.membersLink && <Team setNavLinks={setNavLinks} slidesToShow3={slidesToShow3} setSlidesToShow3={setSlidesToShow3} isWindowReduced={isWindowReduced} />}

        {navLinks.contactLink && <Contact setNavLinks={setNavLinks} status={status} setStatus={setStatus} setisFromContactJs={setisFromContactJs} />}
        {navLinks.signUpLink && <Newsletter setNavLinks={setNavLinks} status1={status1} setStatus1={setStatus1} setisFromContactJs={setisFromContactJs}  />}
        {navLinks.testimonialLink && <Testimonial setNavLinks={setNavLinks} sliderState12={sliderState12} setSliderState12={setSliderState12} handleAfterChange12={handleAfterChange12}/>}

        {/* services Links */}

        {/* hair collections */}
        {navLinks.hairServicesLink && <HairServicePage setNavLinks={setNavLinks}  isWindowReduced={isWindowReduced} handleImageExpansion={handleImageExpansion} slidesToShow1={slidesToShow1} setSlidesToShow1={setSlidesToShow1} slidesToScroll0={slidesToScroll0} setSlidesToScroll0={setSlidesToScroll0}  sliderState1={sliderState1} setSliderState1={setSliderState1} handleAfterChange1={handleAfterChange1}/>}
        {navLinks.hairServicesLink1 && <HairServicePage1 setNavLinks={setNavLinks}  isWindowReduced={isWindowReduced} handleImageExpansion={handleImageExpansion} slidesToShow1={slidesToShow1} setSlidesToShow1={setSlidesToShow1} 
        sliderState2={sliderState2} setSliderState2={setSliderState2} handleAfterChange2={handleAfterChange2}/>}
        {navLinks.hairServicesLink2 && <HairServicePage2 setNavLinks={setNavLinks}  isWindowReduced={isWindowReduced} handleImageExpansion={handleImageExpansion} slidesToShow1={slidesToShow1} setSlidesToShow1={setSlidesToShow1} 
        sliderState3={sliderState3} setSliderState3={setSliderState3} handleAfterChange3={handleAfterChange3}/>}
        {navLinks.hairServicesLink3 && <HairServicePage3 setNavLinks={setNavLinks}  isWindowReduced={isWindowReduced} handleImageExpansion={handleImageExpansion} slidesToShow1={slidesToShow1} setSlidesToShow1={setSlidesToShow1} 
        sliderState4={sliderState4} setSliderState4={setSliderState4} handleAfterChange4={handleAfterChange4}/>}
        {navLinks.hairServicesLink4 && <HairServicePage4 setNavLinks={setNavLinks}  isWindowReduced={isWindowReduced} handleImageExpansion={handleImageExpansion} slidesToShow1={slidesToShow1} setSlidesToShow1={setSlidesToShow1} 
        sliderState5={sliderState5} setSliderState5={setSliderState5} handleAfterChange5={handleAfterChange5}/>}

        {/* Accessories */}
        {navLinks.hairAccessoriesLink && <HairAccessoriesPage setNavLinks={setNavLinks}  isWindowReduced={isWindowReduced} handleImageExpansion={handleImageExpansion} slidesToShow1={slidesToShow1} setSlidesToShow1={setSlidesToShow1} sliderState6={sliderState6} setSliderState6={setSliderState6} handleAfterChange6={handleAfterChange6} />}

        {/* App and Web Dev */}
        {navLinks.appWebDevLink && <AppWebDevPage setNavLinks={setNavLinks}  isWindowReduced={isWindowReduced} handleImageExpansion={handleImageExpansion} vidLinkSettings={vidLinkSettings} slidesToShow2={slidesToShow2} setSlidesToShow2={setSlidesToShow2} sliderState7={sliderState7} setSliderState7={setSliderState7} handleAfterChange7={handleAfterChange7}/>}

        {/* Graphic Designs */}
        {navLinks.graphicDesignLink && <GraphicDesignPage setNavLinks={setNavLinks}  isWindowReduced={isWindowReduced} handleImageExpansion={handleImageExpansion} slidesToShow1={slidesToShow1} setSlidesToShow1={setSlidesToShow1} 
        sliderState8={sliderState8} setSliderState8={setSliderState8} handleAfterChange8={handleAfterChange8}/>}
        {navLinks.graphicDesignLink1 && <GraphicDesignPage1 setNavLinks={setNavLinks}  isWindowReduced={isWindowReduced} handleImageExpansion={handleImageExpansion} slidesToShow1={slidesToShow1} setSlidesToShow1={setSlidesToShow1} 
        sliderState9={sliderState9} setSliderState9={setSliderState9} handleAfterChange9={handleAfterChange9}/>}
        {navLinks.graphicDesignLink2 && <GraphicDesignPage2 setNavLinks={setNavLinks}  isWindowReduced={isWindowReduced} handleImageExpansion={handleImageExpansion} slidesToShow1={slidesToShow1} setSlidesToShow1={setSlidesToShow1} 
        sliderState10={sliderState10} setSliderState10={setSliderState10} handleAfterChange10={handleAfterChange10}/>}
        {navLinks.graphicDesignLink3 && <GraphicDesignPage3 setNavLinks={setNavLinks}  isWindowReduced={isWindowReduced} handleImageExpansion={handleImageExpansion} slidesToShow1={slidesToShow1} setSlidesToShow1={setSlidesToShow1} 
        sliderState11={sliderState11} setSliderState11={setSliderState11} handleAfterChange11={handleAfterChange11}/>}

        {/* Training */}
        {navLinks.trainingLink && <TrainingPage setNavLinks={setNavLinks}  isWindowReduced={isWindowReduced} handleImageExpansion={handleImageExpansion} slidesToShow1={slidesToShow1} setSlidesToShow1={setSlidesToShow1} />}

        {/* Image Enlargment  */}
        {navLinks.expansionLinkForImages && <ImgExpansionPage setNavLinks={setNavLinks}  isWindowReduced={isWindowReduced} handleImageExpansion={handleImageExpansion} imageUrl = {imageData.url} folder = {imageData.folder} imgName = {imageData.imgName} info={imageData.info}  />}

        {/* success page */}
        {navLinks.successLink && <Success setNavLinks={setNavLinks} status={status} setStatus={setStatus} isFromContactJs={isFromContactJs}/>}

      </div>
        
    </div>
  );
}

export default App;
